import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UtilService } from '@service/util/util.service';
import { environment } from '@environment/environment';

@Component({
	selector: 'app-third-step',
	templateUrl: './third-step.component.html',
	styleUrls: ['./third-step.component.css'],
})
export class ThirdStepComponent implements OnInit {
	@Input() allLines: string[];
	@Input() dataType: any = null;
	@Input() errorMsgs: Array<string> = [];

	@Output() goBack: EventEmitter<null> = new EventEmitter();
	@Output() uploadFileEvent: EventEmitter<string[]> = new EventEmitter();

	dataSource = new MatTableDataSource<any>([]);
	PREVIEW_TABLE_PAGE_SIZE = 10;
	PREVIEW_TABLE_HEADERS: Array<string> = null;
	PREVIEW_TABLE_COLUMNS: Array<string> = null;
	DATA_TYPE: Array<string> = [];
	TABLE_ICONS = [];

	RFP_UPLOAD_TYPE = 'priceLane';
	isDataTypeRFP: boolean = false;
	environment = environment;

	PROJECT_UPLOAD_TYPE = 'project';
	isDataTypeProject: boolean = false;

	constructor(private cargochief: Cargochief, public utilService: UtilService) {}

	ngOnInit() {}

	ngOnChanges() {
		if (
			this.errorMsgs.length == 0 &&
			IS_NOT_NULL_OR_UNDEFINED(this.allLines) &&
			this.allLines.length > 0
		) {
			this.buildPreview();
		}
	}

	buildPreview() {
		if (!this.utilService.isNullOrUndefined(this.allLines)) {
			this.PREVIEW_TABLE_HEADERS = this.allLines[0].split(',');
			this.PREVIEW_TABLE_COLUMNS = this.PREVIEW_TABLE_HEADERS.filter((key) =>
				IS_NOT_EMPTY(key)
			).map((key) => key.replace(/\s/g, ''));
			const fileData = this.allLines.slice(1);
			let table: Array<any> = [];
			fileData.map((row, index) => {
				const valueRows = row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
				table[index] = {};
				valueRows.map((value, valuIndex) => {
					table[index][this.PREVIEW_TABLE_COLUMNS[valuIndex]] = value;
				});
			});
			this.PREVIEW_TABLE_COLUMNS.map((key) => this.DATA_TYPE.push('string'));
			this.isDataTypeRFP = this.dataType == this.RFP_UPLOAD_TYPE;
			this.isDataTypeProject = this.dataType === this.PROJECT_UPLOAD_TYPE;
			if (this.isDataTypeRFP || this.isDataTypeProject) {
				this.dataSource = new MatTableDataSource<string>(
					table.slice(0, environment.RFP_PREVIEW_TABLE_ROWS_LIMIT)
				);
			} else {
				this.dataSource = new MatTableDataSource<string>(table);
			}
		}
	}

	uploadFile() {
		this.uploadFileEvent.emit(this.allLines);
	}
}
